import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import useGetConfigurator from 'core/hooks/useGetConfigurator'
import { MobileView, BrowserView, isTablet } from 'react-device-detect'
import * as routes from 'core/routing/constants/index'
import MainContentWrapper from 'core/templates/MainContentWrapper'
import wizardsShape from 'core/components/wizard/shapes'
import { Row, Col, Carousel, Empty, List } from 'core/components/ui'
import PageLoading from 'core/components/page-loading'
import { configuratorShape } from '../shapes'
import MotorItem from './motor-item'
import ListItem from './list-item'

const Motors = props => {
  const { setWizards, wizards, configurator, setConfigurator, history, intl } = props

  const { loading, getVersions, versions } = useGetConfigurator({
    redirectMessage: intl.formatMessage({ id: 'ui-session-expired' })
  })

  const { brand, model, finishes, motor, motorsList } = configurator

  const desactivateNextStep = () => {
    const aStepsActive = wizards[wizards.activeWizard]

    const nextIndex = aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_MOTORS) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: false }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })

    const extentedWizards = { ...wizards, aStepsConfigurator: extendedSteps }
    setWizards(extentedWizards)
  }

  const renderList = () =>
    motorsList.map(item => (
      <Col span={8} key={item.title} data-test="component-configurator-motors-motor-item">
        <MotorItem item={item} data-test="configurator-motors-motor-item" key={item.title} />
      </Col>
    ))

  useEffect(() => {
    const runIt = list => {
      setConfigurator({
        ...configurator,
        motorsList: list
      })
    }

    if (versions) runIt(versions)
  }, [versions])
  useEffect(() => {
    // Redirection if direct access & step is not active

    const aStepsActive = wizards[wizards.activeWizard]

    const extendedStepsActive = aStepsActive.filter(
      step => step.hash === routes.CONFIGURATOR_MOTORS
    )
    const currentStep = extendedStepsActive[0]

    const { isActive } = currentStep

    if (!isActive) {
      history.push(routes.HOME)
    }

    // else load datas

    if (!motor) desactivateNextStep()

    const params = {
      brand: brand.id,
      model: model.id,
      finishes: finishes.title
    }

    getVersions(params)
  }, [])

  return (
    <MainContentWrapper
      title={intl.formatMessage({ id: 'configurator-motors-view-title' })}
      data-test="component-configurator-motors"
    >
      {loading && !motorsList ? (
        <PageLoading data-test="configurator-motors-loading" />
      ) : (
        <Row gutter={16} data-test="configurator-motors-motor-wrapper">
          {motorsList ? (
            <>
              {!isTablet && (
                <BrowserView>
                  <Carousel arrows swipeToSlide draggable slidesToShow={3} infinite={false}>
                    {renderList()}
                  </Carousel>
                </BrowserView>
              )}
              <MobileView>
                <List
                  itemLayout="vertical"
                  dataSource={motorsList}
                  renderItem={item => <ListItem item={item} />}
                />
              </MobileView>
            </>
          ) : (
            <Empty />
          )}
        </Row>
      )}
    </MainContentWrapper>
  )
}

Motors.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  intl: PropTypes.shape().isRequired,
  setWizards: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired,
  setConfigurator: PropTypes.func.isRequired,
  configurator: configuratorShape.isRequired
}

export default withRouter(injectIntl(Motors))
